import { QueryClient } from '@tanstack/react-query';

/**
 * 服务端状态由 TanStack Query 统一管理，不自建 store。
 * 库存数据变化频繁，因此默认 staleTime 很短；真正的正确性永远由服务端保证
 * （Spec §40：不依赖前端状态维护库存正确性）。
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => {
          // 4xx 不重试：权限不足或校验失败重试多少次都一样
          const status = (error as { status?: number }).status;
          if (status !== undefined && status >= 400 && status < 500) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: true,
      },
      mutations: {
        // 变更一律不自动重试：重试由 Idempotency-Key 保护后才安全（A-01），
        // 该机制在 M5 随库存写入一起落地。
        retry: false,
      },
    },
  });
}
